<template>
  <div :class="['sticky-menu', { 'sticky-menu--active': isActive }]" :style="menuStyles">
    <slot />
  </div>
</template>

<script>
import stickyMenuMixin from './sticky-menu-mixin'

const DEFAULT_POSITIONS = {
  parentHeight: null,
  marginTop: 0,
  cssTop: null,
}

export default {
  name: 'PositionSticky',
  mixins: [stickyMenuMixin],

  data() {
    return {
      ...DEFAULT_POSITIONS,
      supportsPositionSticky: true,
    }
  },

  computed: {
    menuStyles() {
      return this.cssTop ? { top: `${this.cssTop}px` } : {}
    },
  },

  watch: {
    parentHeight() {
      this.parentNode.style.height = this.parentHeight ? `${this.parentHeight}px` : ''
    },

    marginTop() {
      this.parentNode.style.marginTop = this.marginTop ? `${this.marginTop}px` : ''
    },
  },

  methods: {
    onStickingToBottomChange(isSticking) {
      if (isSticking) this.resetInitialPosition()
    },

    resetInitialPosition() {
      this.setParentHeight(DEFAULT_POSITIONS.parentHeight)
      this.setMarginTop(DEFAULT_POSITIONS.marginTop)
      this.cssTop = this.isInteractive ? this.getScrollingDownCssTop() : DEFAULT_POSITIONS.cssTop
      this.lastScrollY = 0
      this.updateSpaceLeftBeforeStick()
    },

    isItScrollingDown() {
      return this.lastScrollY < this.getCurrentScrollY()
    },

    isMenuSmallerThanParentHeight() {
      return this.$el.offsetHeight < this.parentMaxHeight
    },

    async afterHeightChange() {
      if (!this.isActive) return

      this.updateHasWindowTallerThanMenu()
      this.updateSpaceLeftBeforeStick()

      await this.$nextTick()
      this.updateParentLayout()
      this.resetParentHeightIfNeeded()

      if (!this.isStickingToBottom) {
        this.isScrollingDown ? this.setScrollingDownPosition() : this.setScrollingUpPosition()
      }
      this.enableScroll()
    },

    updateHasReachedEdge() {
      // Do nothing (only relevant when position sticky is not supported)
    },

    getScrollingDownCssTop() {
      return this.hasWindowTallerThanMenu || this.isStickingToBottom
        ? this.headerHeight
        : window.innerHeight - this.$el.offsetHeight
    },

    setParentHeight(parentHeight) {
      const height =
        parentHeight && !this.hasWindowTallerThanMenu
          ? Math.min(parentHeight, this.parentMaxHeight)
          : ''
      this.parentHeight =
        height && height >= this.$el.offsetHeight && !this.isStickingToBottom ? height : ''
    },

    setMarginTop(marginTop) {
      const safeMarginTop = Math.max(marginTop, 0)
      // The margin-top value shouldn't be more than maxMarginTop, otherwise, it would expand the
      // parent node
      const maxMarginTop = this.parentMaxHeight - this.$el.offsetHeight
      this.marginTop =
        this.$el.offsetHeight < this.parentMaxHeight && !this.isStickingToBottom
          ? Math.min(safeMarginTop, maxMarginTop)
          : DEFAULT_POSITIONS.marginTop
    },

    setWindowTallerThanMenuPosition() {
      this.resetInitialPosition()
    },

    setScrollingDownPosition() {
      this.cssTop = this.getScrollingDownCssTop()
      this.setMarginTop(this.$el.offsetTop + this.marginTop)
      this.setParentHeight(DEFAULT_POSITIONS.parentHeight)
      this.isScrollingDown = true
    },

    setScrollingUpPosition() {
      this.setParentHeight(this.$el.offsetTop + this.marginTop + this.$el.offsetHeight)
      this.cssTop = this.headerHeight
      this.setMarginTop(DEFAULT_POSITIONS.marginTop)
      this.isScrollingDown = false
    },
  },
}
</script>

<style lang="scss" scoped>
.sticky-menu {
  &--active {
    position: sticky;
    top: -1px;
  }
}
</style>
